import {PaymentProvider} from '@/constants/payment-provider';
import BaseProvider from '@/utils/checkout/payment-providers/base-provider';

class KcpProvider extends BaseProvider {
  constructor(options) {
    super(options);
    const {billingAddress, installments, providerCode} = options;

    this.billingAddress = billingAddress;
    this.installments = installments;

    this.providerCode =
      providerCode === PaymentProvider.GR4VY_KCP ? PaymentProvider.GR4VY_KCP : PaymentProvider.CYBERSOURCE_KCP;
  }

  async initializePayment() {
    const data = {
      billingAddress: this.billingAddress,
      paymentProviderCode: this.providerCode,
      paymentOption: this.providerCode,
    };
    return this.submitPaymentInitForm(data);
  }
}

export default KcpProvider;
